import { Product } from '@/fo/ui/product/tile/medium';

export const mockProducts: Product[] = [
  {
    id: 1,
    image: 'https://placeholder.pagebee.io/api/plain/220/220',
    alt: '',
    title: 'Набор для очень сухой, атопичной кожи',
    labels: [{ name: 'Выгода 20%', color: 'orange' }],
    brandLabels: [
      {
        color: '#003A70',
        name: 'Bioderma',
        url: '/bioderma'
      }
    ],
    prices: {
      price: 4800,
      oldPrice: 6000
    }
  },
  {
    id: 2,
    image: 'https://placeholder.pagebee.io/api/plain/220/220',
    alt: '',
    title: 'Набор «Очищение + Уход для сухой атопичной кожи»',
    labels: [{ name: 'Выгода 20%', color: 'orange' }],
    brandLabels: [
      {
        color: '#003A70',
        name: 'Bioderma',
        url: '/bioderma'
      }
    ],
    prices: {
      price: 2710,
      oldPrice: 3390
    }
  }
];
